const domainCards = [
  {
    title: 'iOS Platform',
    description: 'Deep expertise in the iOS ecosystem, leveraging platform-native capabilities and modern frameworks to deliver fluid, responsive, and intuitive digital experiences.',
    gradient: 'from-slate-800 via-slate-700 to-slate-900',
    wide: true,
  },
  {
    title: 'System Design',
    description: 'Scalable architecture patterns that anticipate growth, reduce technical debt, and ensure long-term maintainability across complex software ecosystems.',
    gradient: 'from-stone-700 via-stone-600 to-stone-800',
    wide: false,
  },
  {
    title: 'Engineering Standards',
    description: 'Rigorous code review, automated testing pipelines, and documentation practices that uphold technical excellence across every project.',
    gradient: 'from-neutral-700 via-neutral-600 to-neutral-800',
    wide: false,
  },
];

export default function DomainSection() {
  return (
    <section className="relative bg-white px-4 md:px-6 py-24 md:py-32">
      <div className="max-w-[1140px] mx-auto">
        <div className="mb-16">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.2]">
            Domain
            <span className="inline-flex items-center mx-3">
              <span className="w-8 h-8 border-2 border-foreground-300 inline-block align-middle" style={{ transform: 'rotate(45deg)' }} />
            </span>
            Focus
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1.3fr_1fr_1fr] gap-8">
          {domainCards.map((card, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden group"
              style={{ aspectRatio: '3/4' }}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${card.gradient}`} />
              <div
                className="absolute inset-0 opacity-20"
                style={{
                  backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)`,
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-2">{card.title}</h3>
                <p className="font-body text-sm text-white/75 leading-relaxed">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}